export default "/images/883c8cd6c33ca4ab821a52e062ada402.avif";